module.exports = __webpack_public_path__ + "img/Foto 2 Mudas armazenadas em câmara fria.c5ca2cf9.webp";